// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Decode_Base = require("./Decode_Base.bs.js");
var Relude_NonEmpty = require("relude/src/Relude_NonEmpty.bs.js");
var Decode_ParseError = require("./Decode_ParseError.bs.js");

function handle(t) {
  return t;
}

var Result = Decode_ParseError.ResultOf({
      handle: handle
    });

var include = Decode_Base.Make(Result.TransformError, Result);

var Pipeline = include.Pipeline;

var NonEmptyList_make = Relude_NonEmpty.List.make;

var NonEmptyList_pure = Relude_NonEmpty.List.pure;

var NonEmptyList_cons = Relude_NonEmpty.List.cons;

var NonEmptyList_map = Relude_NonEmpty.List.map;

var NonEmptyList_foldLeft = Relude_NonEmpty.List.foldLeft;

var NonEmptyList_head = Relude_NonEmpty.List.head;

var NonEmptyList_tail = Relude_NonEmpty.List.tail;

var NonEmptyList_toSequence = Relude_NonEmpty.List.toSequence;

var NonEmptyList = {
  make: NonEmptyList_make,
  pure: NonEmptyList_pure,
  cons: NonEmptyList_cons,
  map: NonEmptyList_map,
  foldLeft: NonEmptyList_foldLeft,
  head: NonEmptyList_head,
  tail: NonEmptyList_tail,
  toSequence: NonEmptyList_toSequence
};

var ParseError;

var map = include.map;

var apply = include.apply;

var map2 = include.map2;

var map3 = include.map3;

var map4 = include.map4;

var map5 = include.map5;

var pure = include.pure;

var flatMap = include.flatMap;

var alt = include.alt;

var okJson = include.okJson;

var $$boolean = include.$$boolean;

var string = include.string;

var floatFromNumber = include.floatFromNumber;

var intFromNumber = include.intFromNumber;

var date = include.date;

var variantFromJson = include.variantFromJson;

var variantFromString = include.variantFromString;

var variantFromInt = include.variantFromInt;

var optional = include.optional;

var array = include.array;

var list = include.list;

var tuple = include.tuple;

var tuple2 = include.tuple2;

var tuple3 = include.tuple3;

var tuple4 = include.tuple4;

var tuple5 = include.tuple5;

var tupleAtLeast2 = include.tupleAtLeast2;

var tupleAtLeast3 = include.tupleAtLeast3;

var tupleAtLeast4 = include.tupleAtLeast4;

var tupleAtLeast5 = include.tupleAtLeast5;

var tupleFromFields = include.tupleFromFields;

var dict = include.dict;

var stringMap = include.stringMap;

var at = include.at;

var field = include.field;

var optionalField = include.optionalField;

var fallback = include.fallback;

var oneOf = include.oneOf;

var Pipeline_succeed = Pipeline.succeed;

var Pipeline_pipe = Pipeline.pipe;

var Pipeline_field = Pipeline.field;

var Pipeline_at = Pipeline.at;

var Pipeline_optionalField = Pipeline.optionalField;

var Pipeline_fallbackField = Pipeline.fallbackField;

var Pipeline_fallback = Pipeline.fallback;

var Pipeline_hardcoded = Pipeline.hardcoded;

var Pipeline_run = Pipeline.run;

var Pipeline_map = Pipeline.map;

var Pipeline_apply = Pipeline.apply;

var Pipeline_map2 = Pipeline.map2;

var Pipeline_map3 = Pipeline.map3;

var Pipeline_map4 = Pipeline.map4;

var Pipeline_map5 = Pipeline.map5;

var Pipeline_pure = Pipeline.pure;

var Pipeline_flatMap = Pipeline.flatMap;

var Pipeline_boolean = Pipeline.$$boolean;

var Pipeline_string = Pipeline.string;

var Pipeline_floatFromNumber = Pipeline.floatFromNumber;

var Pipeline_intFromNumber = Pipeline.intFromNumber;

var Pipeline_date = Pipeline.date;

var Pipeline_variantFromJson = Pipeline.variantFromJson;

var Pipeline_variantFromString = Pipeline.variantFromString;

var Pipeline_variantFromInt = Pipeline.variantFromInt;

var Pipeline_optional = Pipeline.optional;

var Pipeline_array = Pipeline.array;

var Pipeline_list = Pipeline.list;

var Pipeline_tuple = Pipeline.tuple;

var Pipeline_tuple2 = Pipeline.tuple2;

var Pipeline_tuple3 = Pipeline.tuple3;

var Pipeline_tuple4 = Pipeline.tuple4;

var Pipeline_tuple5 = Pipeline.tuple5;

var Pipeline_tupleAtLeast2 = Pipeline.tupleAtLeast2;

var Pipeline_tupleAtLeast3 = Pipeline.tupleAtLeast3;

var Pipeline_tupleAtLeast4 = Pipeline.tupleAtLeast4;

var Pipeline_tupleAtLeast5 = Pipeline.tupleAtLeast5;

var Pipeline_tupleFromFields = Pipeline.tupleFromFields;

var Pipeline_dict = Pipeline.dict;

var Pipeline_stringMap = Pipeline.stringMap;

var Pipeline_oneOf = Pipeline.oneOf;

var Pipeline$1 = {
  succeed: Pipeline_succeed,
  pipe: Pipeline_pipe,
  field: Pipeline_field,
  at: Pipeline_at,
  optionalField: Pipeline_optionalField,
  fallbackField: Pipeline_fallbackField,
  fallback: Pipeline_fallback,
  hardcoded: Pipeline_hardcoded,
  run: Pipeline_run,
  map: Pipeline_map,
  apply: Pipeline_apply,
  map2: Pipeline_map2,
  map3: Pipeline_map3,
  map4: Pipeline_map4,
  map5: Pipeline_map5,
  pure: Pipeline_pure,
  flatMap: Pipeline_flatMap,
  $$boolean: Pipeline_boolean,
  string: Pipeline_string,
  floatFromNumber: Pipeline_floatFromNumber,
  intFromNumber: Pipeline_intFromNumber,
  date: Pipeline_date,
  variantFromJson: Pipeline_variantFromJson,
  variantFromString: Pipeline_variantFromString,
  variantFromInt: Pipeline_variantFromInt,
  optional: Pipeline_optional,
  array: Pipeline_array,
  list: Pipeline_list,
  tuple: Pipeline_tuple,
  tuple2: Pipeline_tuple2,
  tuple3: Pipeline_tuple3,
  tuple4: Pipeline_tuple4,
  tuple5: Pipeline_tuple5,
  tupleAtLeast2: Pipeline_tupleAtLeast2,
  tupleAtLeast3: Pipeline_tupleAtLeast3,
  tupleAtLeast4: Pipeline_tupleAtLeast4,
  tupleAtLeast5: Pipeline_tupleAtLeast5,
  tupleFromFields: Pipeline_tupleFromFields,
  dict: Pipeline_dict,
  stringMap: Pipeline_stringMap,
  oneOf: Pipeline_oneOf
};

exports.NonEmptyList = NonEmptyList;
exports.ParseError = ParseError;
exports.map = map;
exports.apply = apply;
exports.map2 = map2;
exports.map3 = map3;
exports.map4 = map4;
exports.map5 = map5;
exports.pure = pure;
exports.flatMap = flatMap;
exports.alt = alt;
exports.okJson = okJson;
exports.$$boolean = $$boolean;
exports.string = string;
exports.floatFromNumber = floatFromNumber;
exports.intFromNumber = intFromNumber;
exports.date = date;
exports.variantFromJson = variantFromJson;
exports.variantFromString = variantFromString;
exports.variantFromInt = variantFromInt;
exports.optional = optional;
exports.array = array;
exports.list = list;
exports.tuple = tuple;
exports.tuple2 = tuple2;
exports.tuple3 = tuple3;
exports.tuple4 = tuple4;
exports.tuple5 = tuple5;
exports.tupleAtLeast2 = tupleAtLeast2;
exports.tupleAtLeast3 = tupleAtLeast3;
exports.tupleAtLeast4 = tupleAtLeast4;
exports.tupleAtLeast5 = tupleAtLeast5;
exports.tupleFromFields = tupleFromFields;
exports.dict = dict;
exports.stringMap = stringMap;
exports.at = at;
exports.field = field;
exports.optionalField = optionalField;
exports.fallback = fallback;
exports.oneOf = oneOf;
exports.Pipeline = Pipeline$1;
/* Result Not a pure module */
